export function getDeployment() {
	if (process.env.NODE_ENV === "production") {
		return window.location.hostname.split(".")[0];
	}
	return "testing";
}

export function getServerHost() {
	return isLocalhost() 
		? "http://localhost:8001/socket"
		: `https://${getDeployment()}.lln.training/socket`;
}

export const isLocalhost = () => {
    const { hostname } = window.location
	return hostname === "localhost";
};
